<template>
    <div>
      <el-row class="tcf-row">
        <el-col class="card">
          <div class="tcf-notedit" v-if="!isauth">
            <div class="tcf-notedit-spinner">
              未授权小程序，<router-link to="/work/delxcxsz" class="a-txt">点击这里立即去授权</router-link>
            </div>
          </div>
          <div class="card-body">
            <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
              <el-form-item label="状态">
                <el-select v-model="searchForm.mark" clearable style="width: 100px">
                  <el-option label="未处理" :value="0" />
                  <el-option label="已处理" :value="1" />
                </el-select>
              </el-form-item>
              <el-form-item label="预约类型">
                <el-select v-model="searchForm.type" clearable style="width: 100px">
                  <el-option label="0元设计" :value="0" />
                  <el-option label="免费报价" :value="1" />
                  <el-option label="预约到店" :value="2" />
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button icon="el-icon-search" @click="Search">搜索</el-button>
              </el-form-item>
            </el-form>
            <div class="card-content" v-loading="loading">
              <el-table
                :data="tableData"
                stripe
                style="width: 100%;margin-bottom: 20px">
                <el-table-column
                  label="预约类型"
                  width="140"
                  align="center"
                  show-overflow-tooltip>
                  <template slot-scope="scope">
                    <span v-if="scope.row.type===0">0元设计</span>
                    <span v-if="scope.row.type===1">免费报价 </span>
                    <span v-if="scope.row.type===2">预约到店</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="name"
                  label="称呼"
                  width="140"
                  align="center"
                  show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                  prop="tel"
                  label="电话"
                  width="140"
                  align="center"
                  show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                  prop="style"
                  label="意向风格"
                  width="140"
                  align="center"
                  show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                  prop="area"
                  label="房屋面积"
                  width="100"
                  align="center"
                  show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                  prop="address"
                  label="详细地址"
                  min-width="200"
                  align="center"
                  show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                  label="导购员"
                  width="100"
                  align="center"
                  fixed="right"
                  show-overflow-tooltip>
                  <template slot-scope="scope">
                    <span style="font-weight: 500;color:#409EFF">{{scope.row.shopname}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="状态"
                  width="100"
                  align="center"
                  fixed="right"
                  show-overflow-tooltip>
                  <template slot-scope="scope">
                    <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===1">已处理</el-tag>
                    <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===0" type="danger">未处理</el-tag>
                  </template>
                </el-table-column>
                <el-table-column
                  label="操作"
                  width="200"
                  align="center"
                  fixed="right"
                  show-overflow-tooltip>
                  <template slot-scope="scope">
                    <el-button :disabled="scope.row.mark===1" icon="el-icon-edit" size="mini" @click="editRow(scope.row)">处理</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                v-if="total>0"
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[20, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
              </el-pagination>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { editDelReservation, getDelReservationList, getDelShopInfo } from '@/api/dealer'

export default {
  name: 'delyyxx',
  computed: {
    user: getUser
  },
  data() {
    return {
      searchForm: {
        mark: null,
        type: null
      },
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      isauth: true
    }
  },
  created() {
    this.getData()
    getDelShopInfo({ delid: this.user.delid }).then(response => {
      if (response.data !== null && response.data !== undefined) {
        if (response.data.appid === null || response.data.appid === '' || response.data.appid === undefined) {
          this.isauth = false
        }
      } else {
        this.isauth = false
      }
    })
  },
  methods: {
    getData() {
      this.loading = true
      const data = {
        delid: this.user.delid,
        page: this.currentPage,
        limit: this.pageSize,
        mark: this.searchForm.mark,
        type: this.searchForm.type
      }
      getDelReservationList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    Search() {
      this.currentPage = 1
      this.getData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    editRow(row) {
      this.$confirm('您确定处理此信息吗?', '提示', {
        confirmButtonText: '是的',
        cancelButtonText: '再看看',
        type: 'warning'
      }).then(() => {
        editDelReservation({ rid: row.rid }).then(response => {
          this.$message({
            type: 'success',
            message: response.msg
          })
          this.getData()
        })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>

</style>
